
export class HistoricalErpSynchronization {
  constructor(
    public hash?: string,
    public startTime?: number,
    public endTime?: number,
    public success?: boolean,
    public synchronizationLimit?: number,
  ) { }

  clone() {
    return new HistoricalErpSynchronization(
      this.hash,
      this.startTime,
      this.endTime,
      this.success,
      this.synchronizationLimit
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/historical-erp-synchronization.ts